import plugin from './dist/vue-textarea-autosize.common.js'
export default plugin
export * from './dist/vue-textarea-autosize.common.js'
